module.exports = __webpack_public_path__ + "img/join.4df24f47.png";